<template>
    <div id="card_grid" class="container-fluid">
        <div class="row full-bleed">
            <div v-for="card in cards" v-bind:class="{ 'col-md-4 col-sm-6': !card.fields.disclaimer, 'col-md-8': card.fields.disclaimer }">
                <router-link
                v-if="card.fields.cardNumber"
                v-bind:to="{ name: 'card_open', params: { card_number: card.fields.cardNumber } }"
                v-on:click.native="set_active">
                    <div class="card_tile" v-bind:class="[card.fields.cardType.toLowerCase(), { double_wide: card.fields.disclaimer }]">
                        <div v-if="card.fields.image" class="card_image" v-bind:style="{ 'background-image': 'url(' + card.fields.image + ')' }"></div>
                        <p v-if="card.fields.disclaimer" class="card_sponsored disclaimer">{{ card.fields.disclaimer }}</p>
                        <div class="card_tile_container">
                            <p class="card_number">{{ card.fields.cardNumber | card_number }}</p>
                            <div class="card_content">
                                <p class="card_title" >{{ card.fields.cardTitle }}</p>
                                <p class="card_teaser">{{ card.fields.cardTeaserCopy }}</p>
                                <p v-if="card.fields.sponsored" class="card_sponsored">presented by toyota c-hr</p>
                            </div>
                            <img v-if="card.fields.cardType.toLowerCase() == 'do'" class="card_icon" src="../assets/img/do.svg" />
                            <img v-else-if="card.fields.cardType.toLowerCase() == 'listen'" class="card_icon" src="../assets/img/listen.svg" />
                            <img v-else-if="card.fields.cardType.toLowerCase() == 'make'" class="card_icon" src="../assets/img/make.svg" />
                            <img v-else-if="card.fields.cardType.toLowerCase() == 'buy'" class="card_icon" src="../assets/img/buy.svg" />
                            <img v-else="card.fields.cardType.toLowerCase() == 'watch'" class="card_icon" src="../assets/img/watch.svg" />
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-8 col-sm-offset-2">
                <div id="card_grid_footer" class="legal">
                    <p class="copyright">© 2016 REFINERY29</p>
                    <p>BY USING OUR SERVICE, YOU AGREE TO OUR <a href="http://www.refinery29.com/terms-and-conditions" style="color:inherit;" target="_blank">TERMS</a> (EFFECTIVE 2/07/2017) AND <a href="http://www.refinery29.com/privacy" style="color:inherit;" target="_blank">PRIVACY</a> (EFFECTIVE 2/07/2017).</p>
                    <p>REFINERY29 NAME & LOGO AND R29 LOGO ARE TRADEMARKS OF REFINERY 29 INC.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as contentful from 'contentful';

    export default {
        name: 'card-grid',
        props: ['cards'],
        filters: {
            card_number: function(number) {
                if (number < 10) {
                    return "0" + number;
                } else {
                    return number;
                }
            }
        },
        methods: {
            set_active: function() {
                this.$emit('cardopen', true);
            }
        }
    }
</script>

<style lang="scss">
    @import '../assets/scss/variables';

    #card_grid {
        max-width: 1600px;
    }

    .card_tile {
        position: relative;
        height: 33.3333vw;
        max-height: 533px;
        cursor: pointer;
        text-align: center;

        &:hover {
            .card_image {
                transform: scale(1.15);
                filter: blur(10px);
            }

            .card_title {
                text-decoration: underline;
            }
        }

        &.do {
            background-color: $red;

            .card_image {
                mix-blend-mode: multiply;
            }
        }

        &.listen {
            background-color: $orange;
        }
        &.make {
            background-color: $yellow;
        }
        &.buy {
            background-color: $pink;
        }
        &.watch {
            background-color: $peach;
        }

        &.double_wide {
            .card_tile_container {
                position: absolute;
                right: 0;
                width: 50%;
            }

            .card_image {
                background-size: 50% auto;
                background-position: left center;
            }

        }

        p {
            color: white;
            text-align: center;

            &.card_title {
                margin-bottom: 15px;
            }
        }
    }

    .card_tile_container {
        width: 100%;
        height: 100%;
    }

    .card_image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        transition: all 0.3s;
        mix-blend-mode: overlay;
        opacity: 0.4;
        filter: grayscale(100%);
    }

    .card_number {
        position: absolute;
        top: 45px;
        width: 100%;
        text-align: center;
        color: white;
    }

    .card_content {
        position: absolute;
        top: 50%;
        left: 34px;
        width: calc(100% - 68px);
        transform: translateY(-50%);
    }

    .card_sponsored {
        text-transform: uppercase;
        font-size: 15px;
        line-height: 18px;
        margin-top: 40px;
        opacity: 0.6;

        &.disclaimer {
            position: absolute;
            bottom: 30px;
            left: 5%;
            width: 40%;
            line-height: 1.25;
            margin: 0;
        }
    }

    .card_icon {
        position: absolute;
        bottom: 45px;
        left: 50%;
        transform: translateX(-50%);
    }

    #card_grid_footer {
        margin: 50px 0;
    }

    @media (max-width: $medium-break) {
        .card_tile {
            height: 50vw;
        }
    }

    @media (max-width: $small-break) {
        #card_grid {
            display: none;
        }
    }

</style>



// WEBPACK FOOTER //
// card-grid.vue?1ac47a1a